import s from "./NotFound.module.css";

const NotFound = () => {
  return (
    <div className={s.wrap}>
      <img
        src="https://pay.vn.ua/uploads/article/img/385/8abc046846c47573dcaeda96f9f45701.jpeg"
        width={1500}
      />
    </div>
  );
};
export default NotFound;
